<template>
  <div id="app">
    <Header :stock="stock" />
    <div class="head-blank">
      <body id="page-top">
        <!-- Header-->

        <section style="margin-top:90px;">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <a :href="lineHref" target="_blank">
                  <img src="./assets/img/l_ball.jpg" width="100%"
                /></a>
              </div>
              <div class="col-lg-6">
                <a :href="lineHref" target="_blank">
                  <img src="./assets/img/l_bar.jpg" width="100%"
                /></a>
              </div>
            </div>
          </div>
        </section>

        <!-- Content section 1-->
        <div>
          <section id="scroll">
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6 order-lg-2">
                  <div class="p-5">
                    <img
                      class="img-fluid"
                      src="./assets/img/ezc-wt-habanero-animation.gif"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                  <div class="pt-4">
                    <h2 class="display-4">
                      5gnextbet คาสิโนออนไลน์ ฝากถอนไม่มีขั้นต่ำ รองรับวอลเล็ท
                      ปลอดภัย100%
                    </h2>
                    <p>
                      คาสิโนออนไลน์ ฝากถอนไม่มีขั้นต่ำ เว็บตรงรองรับพร้อมเพย์
                      เล่นผ่านมือถือ ระบบออโต้100%
                      สมาชิกง่ายไม่มีขั้นต่ำแหล่งรวม คาสิโนยอดนิยม
                      มาตรฐานระดับสากล ความปลอดภัยอันดับ 1
                      ผู้ให้บริการเกมเดิมพัน
                      ที่เปิดรับนักลงทุนทุกคนเข้ามาใช้บริการกับเราได้แบบไม่มีขั้นต่ำ
                      อยากเข้ามาทำกำไรและร่วมสนุก
                      แค่คลิกเข้ามาที่นี่ก็พร้อมใช้บริการได้เลยทันที สมัครคาสิโน
                      ฝากเงินเข้ามาร่วมลงทุนกับทางเว็บพนันออนไลน์ของเราที่นี่
                      5gnextbet
                      มีเงินทุนเพียงแค่หลักหน่วยก็เริ่มต้นความสนุกไปพร้อมกันกับเราได้แล้ว
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Content section 2-->
          <section>
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6">
                  <div>
                    <img
                      class="img-fluid"
                      src="./assets/img/ezc-wt-joker-animation.gif"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div>
                    <p>
                      คาสิโนเว็บตรง 5gnextbet
                      ทำรายการฝากถอนได้อย่างสะดวกรวดเร็วทันใจ
                      รองรับการทำรายการกับธนาคารได้ครอบคลุมทุกสถาบัน
                      และยังรองรับการให้บริการแก่นักเดิมพันผ่านทางพร้อมเพย์
                      PromptpayWallet 5gnextbet คาสิโนที่ดีทีสุด2024
                      ทุกช่องทางที่เราเปิดให้บริการแก่นักลงทุนทุกท่านนั้น
                      มีความสะดวกรวดเร็วในด้านการให้บริการในระดับสูง
                      และยังกล้าการันตีความปลอดภัยในด้านการให้บริการเต็มร้อย
                      รีบคลิกเข้ามาสมัครสมาชิกเพื่อใช้บริการ
                      และสนุกไปพร้อมกันกับทางเว็บพนันของเราได้เต็มที่ลงเดิมพันกับทางเว็บคาสิโนออนไลน์
                      5gnextbet
                      ของเรามีแต่ความเฮงความปังและรับแต่ความมั่งคั่งทางการลงทุนแบบไม่มีหยุดยั้งอย่างแน่นอน
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Content section 3-->
          <section>
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6 order-lg-2">
                  <div>
                    <img
                      class="img-fluid"
                      src="./assets/img/ezc-wt-kalamba.png"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                  <div>
                    <p>
                      คาสิโนออนไลน์เว็บตรง ไม่ผ่านเอเย่นต์
                      รวบรวมเกมเดิมพันมากกว่า 1,000 รายการ คาสิโนออนไลน์
                      เล่นง่ายได้เงินจริงปลอดภัย 100%
                      สามารถเข้ามาตามล่าหาความสนุก
                      และลุ้นรับรางวัลได้อย่างเต็มที่ให้นักเดิมพันได้เข้ามาเปิดประสบการณ์สุดพรีเมียม
                      และสร้างรายได้เข้ากระเป๋าได้ในทุกวัน คาสิโนใหม่ล่าสุด
                      ยอดนิยมอันดับ 1 เลือกลงทุนกับเรานั้นมีแต่ได้กับได้
                      ได้ทั้งความสนุกและโอกาสไปต่อยอดรางวัลใหญ่ 5gnextbet
                      คาสิโนได้เงินจริง
                      พร้อมหอบเงินแสนเงินล้านเข้ากระเป๋าของท่านได้จริง
                      ไม่ต้องเสียเวลาไปตามหา 5gnextbet เว็บคาสิโนออนไลน์
                      ที่อื่นไกลเรานำความสนุกมาให้บริการแบบครบวงจร
                      เลือกเล่นได้เลยอย่างเต็มที่พร้อมพบกับความบันเทิงได้อย่างเต็มรูปแบบ
                      ไม่มีสะดุด
                      พร้อมมันส์และสนุกไปกับเกมระดับเอกซ์คลูซิฟแล้วที่นี่ที่เดียว
                      เล่นได้จากทุกที่ทุกเวลา
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="tt_r  tt_box_chat">
          <div class="tt_l  tt_h_chat">
            <a :href="lineHref" target="_blank" rel="nofollow"
              ><img
                src="./assets/img/b-line.png"
                class="entered lazyloaded"
                data-ll-status="loaded"
                width="36px"
              />
              <!-- <strong>@NEXTBET5G</strong> <i class="fa fa-times-circle"></i> -->
            </a>
          </div>
        </div>
        <!-- Footer-->
        <footer class="py-5 bg-black">
          <div class="container px-5">
            <p class="m-0 text-center text-white small">
              Copyright &copy; NEXTBET5G
            </p>
          </div>
        </footer>
      </body>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "app",
  computed: {
    lineHref: function() {
      return process.env.VUE_APP_LINE_HREF;
    },
    loginHref: function() {
      return process.env.VUE_APP_LOGIN_HREF;
    },
  },
  components: { Header, Carousel, Slide },
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>

<style>
.container {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.container .card {
  cursor: pointer;
  position: relative;
  height: 154px;
  background: rgba(255, 255, 255, 0);
  margin: 20px;
  display: flex;
  align-items: center;
  backdrop-filter: blur(10px);
}

.container-text {
  position: relative;

  background: rgba(255, 255, 255, 0.05);
  margin: 10px 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}

.container .card .content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: 0.5s;
}

.container .card:hover .content {
  transform: translateY(-20px);
}

.container .card .content .imgBx {
  position: relative;
  width: 379px;
  height: 150px;
  overflow: hidden;
}

.container .card .content .imgBx img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.container .card .content .contentBx h3 {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin: 20px 0 10px;
  line-height: 1.1em;
}

.container .card .content .contentBx h3 span {
  font-size: 12px;
  font-weight: 300;
  text-transform: initial;
}

.container .card .sci {
  position: absolute;
  bottom: 50px;
  display: flex;
}

.container .card .sci li {
  list-style: none;
  margin: 0 10px;
  transform: translateY(40px);
  transition: 0.5s;
  opacity: 0;
}

.container .card:hover .sci li {
  transform: translateY(0px);
  opacity: 1;
}

.container .card .sci li a {
  text-decoration: none;
  color: #fff;
  font-size: 20px;
}

h2 {
  color: #fff;
  font-size: 25px !important;
  font-weight: bold !important;
  color: orange;
}
p {
  color: #fff;
}

.tt_box_chat {
  position: fixed;
  right: 20px;
  top: 100px;
  border-radius: 10px 10px 10px 10px;

  height: 50px;
  z-index: 100;
  overflow: hidden;
}

.tt_box_chat .tt_h_chat {
  float: left;
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  /* padding: 5px 10px 5px 5px; */
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  font-weight: 700;
  cursor: pointer;
  background: #32c238;
  border: 0;
}
.tt_box_chat a {
  color: #fff;
  text-decoration: none;
}
.tt_box_chat a:hover {
  color: #fff;
}

.link-in {
  color: #fbc672;
  text-align: center;
  text-decoration: none;
  border-radius: 50px;
  border: 1.5px solid #fbc672;
  transition: all 0.6s;
  cursor: pointer;
}
.link-in:hover {
  color: #fff;
  border: 1.5px solid #fff;
  text-decoration: none;
}
.mobile-display {
  display: block !important;
}

@media screen and (min-width: 991px) {
  .mobile-display {
    display: none !important;
  }
}
</style>
